// Maybe in the future these can be classes that have handling for youtube, vimeo, etc

/**
 * Assumes `onYouTubeIframeAPIReady` has been called
 * by the 3rd-party YouTube script and `YT.Player` exists
 */
export const initYoutubeIframe = (iframe) => {
  const youtubePlayer = new YT.Player(iframe, {
    events: {
      onStateChange: function (event) {
        var isPlaying = event.data === 1;
        if (isPlaying) {
          // Pause other players
          window.CMYoutubePlayers.filter(
            (player) =>
              event.target.playerInfo.videoData.video_id !==
              player.playerInfo.videoData.video_id
          ).forEach((player) => player.pauseVideo());
        }
      },
    },
  });
  window.CMYoutubePlayers.push(youtubePlayer);
};

export const initYoutubeIframeAPI = () => {
  // Select all youtube embeds but NOT /talk videos, which are instantiated separately
  var youtubeIframes = [
    ...document.querySelectorAll(
      'iframe[src*="youtube.com/embed"]:not(.js-vid-embed)'
    ),
  ];

  window.youtubeEG = youtubeIframes[0];

  if (youtubeIframes.length) {
    // Normalize URLs before initializing API
    youtubeIframes.forEach((iframe) => {
      const src = new URL(iframe.src);

      // Request SSL regardless of what the user entered
      src.protocol = "https:";

      // Some embeds (eg from tumblr) add their own origin here
      src.searchParams.set("origin", window.location.origin);

      // Required for YouTube iframe API
      src.searchParams.set("enablejsapi", "1");

      // Required for YouTube iframe API
      src.searchParams.set("feature", "oembed");
      src.searchParams.set("wmode", "opaque");
      src.searchParams.set("rel", "0");

      iframe.src = src;
    });

    // YouTube script that puts YT.Player in the window context
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Window context because we need access to these everywhere
    window.CMYoutubePlayers = [];
  }

  // Function called from youtube's iframe_api script
  window.onYouTubeIframeAPIReady = function () {
    youtubeIframes.forEach(initYoutubeIframe);

    // Init CM Youtube Videos (`/talks videos)
    if (window.onCMYouTubeIframeAPIReady) {
      window.onCMYouTubeIframeAPIReady();
    }
  };
};

export default initYoutubeIframeAPI;



// WEBPACK FOOTER //
// ./app/javascript/lib/youtube-iframes.js